import { ArrowForward, CalendarTodayRounded, CloseRounded, LabelImportantRounded, MoreVert } from '@mui/icons-material'
import {
  Box,
  Button,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  useTheme
} from '@mui/material'
import clsx from 'clsx'
import { MouseEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { deleteSeminarLesson, setViewSeminarLesson, showSeminarLesson } from '../../../../../redux/actions/seminarlessons'
import { IRootState } from '../../../../../redux/types'
import CustomSnackBar from '../../../../shared/components/CustomSnackBar'
import ScreenLoading from '../../../../shared/components/ScreenLoading'
import { CancelButton, DeleteButton } from '../../../../shared/components/inputs'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import { formsStyles } from '../../../../shared/styles/FormsStyles'
import { seminarGlobalStyles } from '../../../../shared/styles/SeminarGlobalStyles'
import { Lessons } from '../../../../shared/styles/SeminarGlobalStyles'
import { VipLessonBlock, VipText } from '../../../../shared/styles/VipStyles'

type SeminarLessonBlockProps = {
  seminarlesson: any
  hasaccess: boolean
  vipContent: boolean
}

function SeminarLessonBlock({ seminarlesson, vipContent, hasaccess }: SeminarLessonBlockProps) {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const theme = useTheme()
  const classes = seminarGlobalStyles(theme)
  const formClasses = formsStyles(theme)
  const dispatch = useDispatch()
  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { loading, msg, error } = useSelector((state: IRootState) => state.lesson)
  const [anchorOp, setAnchorOp] = useState<null | HTMLElement>(null)
  const [openOptions, setOpenOptions] = useState(false)
  const [openDeleteLesson, setOpenDeleteLesson] = useState(false)
  const [lessonSelected, setLessonSelected] = useState(false)

  const handleCloseOptions = () => {
    setAnchorOp(null)
    setOpenOptions(false)
  }

  const handleClickLesson = () => {
    dispatch(setViewSeminarLesson(seminarlesson))
  }

  return (
    <>
      <Lessons>
        <CardContent>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item xs={1} sm={2} onClick={() => handleClickLesson()}>
              <Box width="100%" justifyContent="center" display="flex">
                <LabelImportantRounded className={clsx(classes.lessonPlay, 'new')} />
              </Box>
            </Grid>

            <Grid item xs={9} onClick={() => handleClickLesson()}>
              <Box pl={isMobile ? 2 : 0}>
                <Typography variant="subtitle1">{seminarlesson.title}</Typography>
                {seminarlesson.datatime != null && (
                  <Box display="flex" gap={8} alignItems="center" pt={isMobile ? 0 : 1}>
                    <CalendarTodayRounded fontSize="inherit" />
                    <Typography color="inherit">{seminarlesson.datetime}</Typography>
                  </Box>
                )}
                <VipText display="flex" gap={8} alignItems="center" pt={isMobile ? 0 : 1}>
                  <>
                    <Typography>{t('more-info')}</Typography>
                    {vipContent ? <ArrowForward color="inherit" style={{ fill: '#B49568' }} /> : <ArrowForward color="inherit" />}
                  </>
                </VipText>
              </Box>
            </Grid>

            <Grid item xs={2} sm={1}>
              {authUser != null && [1, 2, 5].includes(authUser.role_id) && (
                <>
                  <IconButton
                    id={`icon-button-${seminarlesson.id}`}
                    aria-controls="icon-menu"
                    aria-haspopup="false"
                    onClick={(event: MouseEvent<HTMLButtonElement>) => {
                      setAnchorOp(event.currentTarget)
                      setOpenOptions(true)
                    }}
                  >
                    <MoreVert />
                  </IconButton>
                  <Menu
                    id={`simple-menu-${seminarlesson.id}`}
                    anchorEl={anchorOp}
                    keepMounted
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    open={openOptions}
                    onClick={handleCloseOptions}
                    onClose={handleCloseOptions}
                  >
                    <MenuItem onClick={() => dispatch(setViewSeminarLesson(seminarlesson))}>{t('view')}</MenuItem>
                    <MenuItem onClick={() => dispatch(showSeminarLesson(seminarlesson.id))}>{t('edit')}</MenuItem>
                    <MenuItem
                      onClick={() => {
                        setOpenDeleteLesson(!openDeleteLesson)
                        setLessonSelected(seminarlesson.id)
                      }}
                    >
                      {t('delete')}
                    </MenuItem>
                  </Menu>
                </>
              )}
            </Grid>
          </Grid>
        </CardContent>
        {vipContent && !hasaccess && (
          <VipLessonBlock alignContent="center" textAlign="center">
            <Typography variant="subtitle1" color="inherit">
              Este es un contenido
            </Typography>
            <Typography variant="h5" color="inherit">
              VIP
            </Typography>
          </VipLessonBlock>
        )}
      </Lessons>

      <Dialog
        open={openDeleteLesson}
        fullWidth={true}
        fullScreen={isMobile && true}
        maxWidth={!isMobile && 'sm'}
        sx={formClasses.containerForm}
        onClose={() => setOpenDeleteLesson(!openDeleteLesson)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Grid container justifyContent="space-between">
            <Typography variant="h6">Eliminar Lección</Typography>
            <Button onClick={() => setOpenDeleteLesson(!openDeleteLesson)} color="primary" variant="text">
              <CloseRounded />
            </Button>
          </Grid>
        </DialogTitle>
        <DialogContent sx={formClasses.bodyForm}>
          <Grid container alignItems="flex-start" spacing={2}>
            <Grid item xs={12}>
              <Typography>¿Está seguro que desea eliminar el lección?</Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={() => setOpenDeleteLesson(!openDeleteLesson)}>{t('cancel')}</CancelButton>
          <DeleteButton
            id="btn-handlelogin"
            onClick={() => {
              dispatch(deleteSeminarLesson(lessonSelected))
              setOpenDeleteLesson(!openDeleteLesson)
            }}
          >
            {t('delete')}
          </DeleteButton>
        </DialogActions>
      </Dialog>

      <CustomSnackBar errors={[error]} msgs={[msg]} />
      <ScreenLoading loadings={[loading]} />
    </>
  )
}

export default SeminarLessonBlock
